import { Component } from '@angular/core';
import { SharedModule } from 'src/app/core/shared.module';

@Component({
  selector: 'v-public-bottom-gradient-wrapper',
  templateUrl: './bottom-gradient.component.html',
  imports: [SharedModule],
})
export class VBottomGradientWrapperComponent {}
